const recentBlog = () => {
  const width = $(window).width();
  function initSlick() {
    const oDOM = $('.recent-blog-section .blog-wrapper');
    if (oDOM) {
      let settings = {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        variableWidth: true,
        touchThreshold: 100,
        prevArrow: `<span class='slick-prev'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="13" viewBox="0 0 30 13" fill="none">
                <path d="M29.1 7.06237V7.16237H29L3.3838 7.16237L7.33817 11.1343L7.40843 11.2048L7.33816 11.2754L6.54625 12.0706L6.47538 12.1417L6.40452 12.0706L0.929131 6.57055L0.858895 6.5L0.929131 6.42945L6.40452 0.929448L6.47538 0.858274L6.54625 0.929436L7.33816 1.72463L7.40843 1.79518L7.33817 1.86575L3.3838 5.83763L29 5.83763H29.1V5.93763V7.06237Z" fill="black" stroke="black" stroke-width="0.2"/>
                </svg></span>`,
        nextArrow: `<span class='slick-next'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="13" viewBox="0 0 30 13" fill="none">
                <path d="M0.9 5.93763V5.83763H1H26.6162L22.6618 1.86575L22.5916 1.79518L22.6618 1.72463L23.4538 0.929436L23.5246 0.858273L23.5955 0.929448L29.0709 6.42945L29.1411 6.5L29.0709 6.57055L23.5955 12.0706L23.5246 12.1417L23.4538 12.0706L22.6618 11.2754L22.5916 11.2048L22.6618 11.1343L26.6162 7.16237H1H0.9V7.06237V5.93763Z" fill="black" stroke="black" stroke-width="0.2"/>
                </svg></span>`,
      };

      // mobile screens
      if (width <= 768) {
        settings = {
          dots: false,
          arrows: false,
          infinite: true,
          slidesToShow: 1,
          variableWidth: false,
          touchThreshold: 100,
        };

        // tablet screens
      } else if (width <= 820) {
        settings = {
          dots: false,
          arrows: false,
          infinite: true,
          slidesToShow: 2,
          variableWidth: false,
          touchThreshold: 100,
        };

        // larger screens
      } else if (width >= 1700) {
        settings.slidesToShow = 1;
      }

      oDOM.not('.slick-initialized').slick(settings);
    }
  }

  $(window)
    .on('resize', function () {
      initSlick();
      // Invoke the resize event immediately
    })
    .resize();

  // Trigger slick in homepage hero banner when customizing theme
  $(window).on('shopify-custom-recent-blog-event', function () {
    initSlick();
  });
};

export default recentBlog;
